import React, { Fragment } from "react";

import Header from "../../components/header/header";

import "./privacy.scss";

const Privacy = () => (
  <Fragment>
    <Header />
    <section className="page_container">
      <div className="privacy_policy">
        <h1>Privacy Policy</h1>
        <p>
          PiRentz is an application (hereinafter referred to as an “app”)
          developed by PiRentz Private Limited, an Indian company incorporated
          under the Companies Act, 1956 with its registered office at HIG- B156,
          MP Housing Society, Ayodhya Nagar Extension, Bhopal - 462041, India.
          We value the trust you place in us and hence insist upon the highest
          standards for secure transactions and customer information privacy.
          This Privacy Statement is designed to help you obtain information
          about our privacy practices and to help you understand your privacy
          choices when you use our app and Services. Please note that our
          Service offerings may vary by region.
        </p>
        <h4>Note:</h4>
        <p>
          Our privacy policy is subject to change at any time without notice.
          Though every effort would be made to keep you informed of the changes,
          if any, to the policy, you are kindly advised to review the policy
          periodically.
        </p>
        <p>
          By downloading this app you agree to be bound by the terms and
          conditions of this Privacy Policy. As this policy enables us to
          provide you a secure and wholesome experience, we will not be able to
          register you, if you are not in agreement with these terms.
        </p>
        <p>
          By registering or merely using the app, you expressly consent to our
          use and disclosure of your personal information in accordance with
          this Privacy Policy. This Privacy Policy is incorporated into and
          subject to the Terms of Use.
        </p>
        <h3>
          Collection of Personally Identifiable Information and other
          Information
        </h3>
        <h4>Information You Provide to Us:</h4>
        <p>
          We receive and store any information you provide to us. For example,
          we collect Personal Information such as your name, email address, Bank
          Account information, PAN Account Number, GST number. Our primary goal
          in doing so is to endeavor a safe, efficient, smooth and customized
          experience. This allows us to provide services and features that most
          likely meet your needs, and to make your experience safer and easier.
          More importantly, while doing so we collect personal information from
          you that we consider necessary for achieving this. You can choose not
          to provide us with certain information, but then you may not be able
          to register with us or to take advantage of some of our features.
        </p>
        <h4>Information Collected Automatically:</h4>
        <p>
          <strong>Usage and Log Information: </strong>We collect
          service-related, diagnostic, and performance information. This
          includes information about your activity (such as how you use our
          Services, how you interact with others using our Services, and the
          like), log files, and diagnostic, crash, website, and performance logs
          and reports.
        </p>
        <p>
          <strong>Location Information: </strong>Whenever you interact with our
          Services, we automatically receive and record information on our
          server logs about your GPS location.
        </p>
        <p>
          Transactional Information. If you pay for our Services, we may receive
          information and confirmations, such as payment receipts, including
          from app stores or other third parties processing your payment.
        </p>
        <h3>How We Use Information</h3>
        <p>
          We use all the information we have to help us operate, provide,
          improve, understand, customize, support, and market our Services.
        </p>
        <p>
          <strong>Our Services: </strong>We operate and provide our Services,
          including providing customer support, and improving, fixing, and
          customizing our Services. We understand how people use our Services,
          and analyze and use the information we have to evaluate and improve
          our Services, research, develop, and test new services and features,
          and conduct troubleshooting activities. We also use your information
          to respond to you when you contact us.
        </p>
        <p>
          <strong>Safety and Security: </strong>We verify accounts and activity,
          and promote safety and security on and off our Services, such as by
          investigating suspicious activity or violations of our Terms, and to
          ensure our Services are being used legally.
        </p>
        <p>
          <strong>No Third-Party Banner Ads: </strong>We do not allow
          third-party banner ads on PiRentz. We have no intention to introduce
          them, but if we ever do, we will update this policy.
        </p>
        <h3>Will company share any of the personal information it receives?</h3>
        <p>
          We neither rent nor sell your Personal Information in personally
          identifiable form to anyone. However, we do share your Personal
          Information with third parties as described below:
        </p>
        <p>
          <strong>Agents: </strong>We employ other companies and people to
          perform tasks on our behalf and need to share your information with
          them to provide products or services to you. Unless we tell you
          differently, our agents do not have any right to use the Personal
          Information we share with them beyond what is necessary to assist us.
        </p>
        <p>
          <strong>User Profiles and Submissions: </strong>Certain user profile
          information, including without limitation a user’s name, location, and
          any video or image content that such user has uploaded to the
          Services, may be displayed to other users to facilitate user
          interaction within the Services or address your request for Company’s
          services. Any content you upload to your public user profile, along
          with any Personal Information or content that you voluntarily disclose
          online in a manner other users can view becomes publicly available,
          and can be collected and used by others. Again, we do not control the
          policies and practices of any other third party site or service which
          may interact with our Services.
        </p>
        <p>
          <strong>Assignment, Change Of Control, And Transfer: </strong>All of
          our rights and obligations under our Privacy Policy are freely
          assignable by us to any of our affiliates, in connection with a
          merger, acquisition, restructuring, or sale of assets, or by operation
          of law or otherwise, and we may transfer your information to any of
          our affiliates, successor entities, or new owner.
        </p>
        <p>
          <strong>Law And Protection: </strong>We reserve the right to access,
          read, preserve, and disclose any information that we reasonably
          believe is necessary to comply with law or court order; enforce or
          apply our conditions of use and other agreements; or protect the
          rights, property, or safety of Company, our employees, our users, or
          others.
        </p>
        <p>
          <strong>With Your Consent: </strong>Except as set forth above, you
          will be notified when your Personal Information may be shared with
          third parties in personally identifiable form, and will be able to
          prevent the sharing of this information.
        </p>
        <p>
          <strong>Security Precautions: </strong>Our app has stringent security
          measures in place to protect the loss, misuse, and alteration of the
          information under our control. Whenever you change or access your
          account information, we offer the use of a secure server. Once your
          information is in our possession we adhere to strict security
          guidelines, protecting it against unauthorized access.
        </p>
        <h3>Changes to this privacy policy</h3>
        <p>
          We may amend this Privacy Policy from time to time. If we make changes
          in the way we use Personal Information, we will notify you (for
          example, by email or a sign-in notification or some other means). By
          continuing to use the Service after those changes become effective,
          you are agreeing to be bound by the revised Privacy Policy; if you do
          not agree to the change, simply don’t use the Service after the change
          is effective, in which case the change will not apply to you.
        </p>
        <h3>Questions or concerns</h3>
        <p>
          If you have any questions or concerns regarding our privacy policies,
          please send us a detailed message to privacy@pirentz.com, and we will
          try to resolve your concerns.
        </p>
      </div>
    </section>
  </Fragment>
);

export default Privacy;
